const angular = require('angular')

module.exports = angular
  .module('mw.usage-report', [
    require('angular-ui-router'),
    require('../base-states'),
    require('./usage-report.directive'),
  ])
  .config($stateProvider => {
    $stateProvider
      .state('monkeywrench.base.usage-report', {
        abstract: true,
        url: '/usage-report',
        views: {
          body: {
            template: '<div ui-view><usage-report/></div>',
          },
        },
        data: {
          greyBackGround: true,
        },
      })
      .state('monkeywrench.base.usage-report.index', {
        url: '/index',
        template: '<usage-report></usage-report>',
      })
  }).name
